export default __webpack_public_path__ + "static/media/idPicture.1a421d3c.jpeg";